<template>
  <div>
    <div class="page page--modal">
      <div class="flyout__modal-close" @click="cancel">
        <span class="flyout__modal-closex">X</span>
      </div>
      <div class="page__header">
        <div class="page__header-title">
          {{ mode == "add" ? "Add User" : "Edit User" }}
          <div class="page__header-subtitle">
            {{
              mode == "add" ? "You can add End Users" : "You can edit End Users"
            }}
          </div>
        </div>
      </div>
      <hr />
      <div class="page__body">
        <form ref="form" autocomplete="off" @submit.prevent="addUser()">
          <div class="form__content">
            <b-row class="form__row">
              <b-col>
                <b-form-group
                  label="First Name"
                  label-size="sm"
                  label-class="form__label"
                >
                  <span class="form__label-star">*</span>
                  <b-form-input
                    v-model="userData.firstName"
                    placeholder="Enter First Name"
                    required
                    size="sm"
                    trim
                    maxlength="15"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  label="Last Name"
                  label-size="sm"
                  label-class="form__label"
                >
                  <span class="form__label-star">*</span>
                  <b-form-input
                    v-model="userData.lastName"
                    placeholder="Enter Last Name"
                    required
                    size="sm"
                    trim
                    maxlength="15"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="mode == 'add'" class="form__row">
              <b-col>
                <b-form-group
                  label="Password"
                  label-size="sm"
                  label-class="form__label"
                >
                  <span class="form__label-star">*</span>
                  <b-form-input
                    type="password"
                    v-model="userData.password"
                    placeholder="Enter Password"
                    required
                    size="sm"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  label="Confirm Password"
                  label-size="sm"
                  label-class="form__label"
                >
                  <span class="form__label-star">*</span>
                  <b-form-input
                    type="password"
                    v-model="userData.confirmPwd"
                    placeholder="Confirm Password"
                    required
                    size="sm"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="mb-2 ml-1">
                <b-form-invalid-feedback :state="passwordMatch"
                  >New password and confirm password does not
                  match</b-form-invalid-feedback
                >
                <b-form-invalid-feedback :state="passwordCharacters"
                  >Password should contain at least one uppercase, one special
                  character and one numeric character, should be at least 8
                  characters long, should not contain
                  whitespaces.</b-form-invalid-feedback
                >
              </b-col>
            </b-row>
            <b-row class="form__row">
              <b-col>
                <b-form-group
                  v-if="userData.email || mode == 'add'"
                  label="Email"
                  label-size="sm"
                  label-class="form__label"
                >
                  <span class="form__label-star">*</span>
                  <b-form-input
                    type="email"
                    v-model="userData.email"
                    placeholder="Enter Email"
                    required
                    size="sm"
                    :formatter="formatter"
                    trim
                    pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                    :disabled="mode != 'add'"
                    maxlength="50"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  v-if="!userData.email && mode != 'add'"
                  label="User Identifier"
                  label-size="sm"
                  label-class="form__label"
                >
                  <span class="form__label-star">*</span>
                  <b-form-input
                    v-model="userData.userIdentifier"
                    placeholder="User Identifier"
                    required
                    size="sm"
                    disabled="true"
                    maxlength="50"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  label="Age"
                  label-size="sm"
                  label-class="form__label"
                >
                  <span class="form__label-star">*</span>
                  <b-form-input
                    v-model="userData.age"
                    placeholder="Enter Age"
                    required
                    size="sm"
                    step="0.01"
                    type="number"
                    trim
                  ></b-form-input> </b-form-group
                ><b-form-invalid-feedback :state="minimumAge"
                  >Please note age should be in between 3 to 100
                  years.</b-form-invalid-feedback
                >
              </b-col>
            </b-row>
            <b-row class="form__row">
              <b-col>
                <b-form-group
                  label="Height(in feet)"
                  label-size="sm"
                  label-class="form__label"
                >
                  <span class="form__label-star">*</span>
                  <b-form-input
                    v-model="userData.height"
                    placeholder="Enter Height"
                    required
                    size="sm"
                    type="number"
                    step="0.001"
                    trim
                  ></b-form-input>
                </b-form-group>
                <b-form-invalid-feedback :state="minimumHeight"
                  >Please note height should be in between 1 to 7
                  feet.</b-form-invalid-feedback
                >
              </b-col>
              <b-col>
                <b-form-group
                  label="Weight(in Kg)"
                  label-size="sm"
                  label-class="form__label"
                >
                  <span class="form__label-star">*</span>
                  <b-form-input
                    v-model="userData.weight"
                    placeholder="Enter Weight"
                    required
                    size="sm"
                    type="number"
                    step="0.001"
                    name="Weight"
                    trim
                  ></b-form-input>
                </b-form-group>
                <b-form-invalid-feedback :state="minimumWeight"
                  >Please note weight should be in between 5 to
                  300kgs.</b-form-invalid-feedback
                >
              </b-col>
            </b-row>
          </div>
          <hr />
          <div class="form__buttons">
            <b-button
              class="form__button_left"
              size="sm"
              variant="light"
              @click="cancel()"
              >Cancel</b-button
            >
            <b-button
              class="form__button_right"
              size="sm"
              variant="success"
              v-if="mode == 'add'"
              type="submit"
              >Add User</b-button
            >
            <b-button
              class="form__button_right"
              size="sm"
              variant="success"
              v-if="mode != 'add'"
              type="submit"
              >Update</b-button
            >
          </div>
        </form>
      </div>
    </div>
    <loader v-if="view.addingUser || view.updatingUser"></loader>
  </div>
</template>

<script>
import toast from "../../toaster.js";
import { createNamespacedHelpers } from "vuex";

const { mapGetters, mapActions } = createNamespacedHelpers("admin/usersView");
export default {
  data: function () {
    return {
      userData: {},
    };
  },

  props: {
    mode: {
      type: String,
    },
    user: {
      type: Object,
    },
  },

  computed: {
    ...mapGetters(["allUserList"]),

    view() {
      return this.$store.state.admin.usersView;
    },

    passwordMatch() {
      if (this.userData.password && this.userData.confirmPwd)
        return this.userData.password === this.userData.confirmPwd;
      return true;
    },

    passwordCharacters() {
      let string = this.userData.password;
      if (
        string == undefined ||
        (/\d/.test(string) &&
          /[a-z]/.test(string) &&
          /[A-Z]/.test(string) &&
          /[*.!@#$%^&(){}:";'<>,.?/`_+-=|\\]/.test(string) &&
          !/\s/g.test(string) &&
          string.length > 7)
      ) {
        return true;
      }
      return false;
    },

    minimumAge() {
      if (this.userData.age < 3 || this.userData.age > 100) {
        return false;
      }
      return true;
    },
    minimumWeight() {
      if (this.userData.weight < 5 || this.userData.weight > 300) {
        return false;
      }
      return true;
    },
    minimumHeight() {
      if (this.userData.height < 1 || this.userData.height > 7) {
        return false;
      }
      return true;
    },
  },

  mounted() {
    if (this.mode != "add") {
      this.userData = this.user;
    }
  },

  methods: {
    cancel(e) {
      this.$emit("cancel");
    },

    formatter(value) {
      return value.toLowerCase();
    },

    addUser() {
      if (
        this.mode == "add" &&
        this.passwordMatch &&
        this.passwordCharacters &&
        this.minimumAge &&
        this.minimumHeight &&
        this.minimumWeight
      ) {
        this.userData.role = "Enduser";
        this.$emit("addUser", { vm: this, data: this.userData });
      } else if (
        this.mode != "add" &&
        this.minimumAge &&
        this.minimumHeight &&
        this.minimumWeight
      ) {
        this.$emit("updateUser", { vm: this, data: this.userData });
      }
    },
  },
};
</script>

<style scoped>
hr {
  margin: 3px !important;
}
</style>
